import { heroEquipment } from "../HeroEquipment";

export const leśne = {
  heroes: {
    Szlachcic: {
      id: 0,
      startingEquipment: ["Sztylet", "Łuk elfów"],
      cost: 70,
      number: 1,
      equipmentList: heroEquipment["Leśni Elfowie z Athel Loren"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 5, 5, 3, 3, 2, 6, 1, 9],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: [
        "Dowódca",
        "Nadrzewni drapieżcy",
        "Ranger",
        "Szósty zmysł",
        "Sztuka łucznicza",
        "Zasadzka",
        "Zew dziczy",
      ],
      exp: 20,
      skills: [0, 1, 2, 4, 5],
    },
    "Mag elfów": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 50,
      number: 1,
      equipmentList: heroEquipment["Leśni Elfowie z Athel Loren"].Mag,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: [
        "Mag (Magia Asrai)",
        "Nadrzewni drapieżcy",
        "Ranger",
        "Szósty zmysł",
        "Sztuka łucznicza",
        "Zasadzka",
      ],
      exp: 12,
      skills: [0, 1, 2, 4, 5],
    },
    "Wieczny Strażnik": {
      id: 2,
      startingEquipment: ["Sztylet", "Saearath"],
      cost: 45,
      number: 1,
      equipmentList: heroEquipment["Leśni Elfowie z Athel Loren"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 5, 4, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: [
        "Nadrzewni drapieżcy",
        "Ranger",
        "Szósty zmysł",
        "Sztuka łucznicza",
        "Zasadzka",
      ],
      exp: 11,
      skills: [0, 3, 4, 5],
    },
    "Strażnik ścieżek": {
      id: 3,
      startingEquipment: ["Sztylet", "Łuk elfów"],
      cost: 45,
      number: 1,
      equipmentList: heroEquipment["Leśni Elfowie z Athel Loren"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 5, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: [
        "Nadrzewni drapieżcy",
        "Pułapkarz",
        "Ranger",
        "Szósty zmysł",
        "Sztuka łucznicza",
        "Zasadzka",
      ],
      exp: 11,
      skills: [0, 1, 4, 5],
    },
    "Strażnik polany": {
      id: 4,
      startingEquipment: ["Sztylet", "Łuk długi"],
      cost: 40,
      number: 12,
      equipmentList: heroEquipment["Leśni Elfowie z Athel Loren"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Nadrzewni drapieżcy",
        "Ranger",
        "Szósty zmysł",
        "Sztuka łucznicza",
        "Zasadzka",
      ],
    },
    "Tancerz wojny": {
      id: 5,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 50,
      number: 3,
      equipmentList: heroEquipment["Leśni Elfowie z Athel Loren"]["Tancerz"],
      type: "Stronnik",
      stats: {
        Początkowa: [5, 5, 4, 3, 3, 1, 5, 1, 10],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: ["Fanatyk","Nadrzewni drapieżcy","Ochronne tatuaże","Ranger","Szósty zmysł","Sztuka łucznicza","Tańce cienia loeca","Śmigły","Zasadzka"],
    },
    Driada: {
      id: 6,
      startingEquipment: ["Broń naturalna (przebicie pancerza)"],
      cost: 50,
      number: 3,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 0, 4, 4, 1, 6, 2, 8],
        Maksymalna: [5, 4, 0, 4, 4, 1, 6, 2, 8],
      },
      rules: [
        "Leśny duch",
        "Łatwopalny",
        "Łuskowata skóra (5+)",
        "Oplątanie",
        "Zew dziczy",
      ],
    },
    "Jeździec polany": {
      id: 7,
      startingEquipment: [
        "Sztylet",
        "Łuk długi",
        "Rumak Elfów",
        "Siodło & uprząż",
      ],
      cost: 80,
      number: 3,
      equipmentList: heroEquipment["Leśni Elfowie z Athel Loren"].Jeździec,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
        "Rumak Elfów": [9, 3, 0, 3, "-", "-", 4, 1, 5],
      },
      rules: [
        "Kawalerzysta",
        "Lekka jazda",
        "Nadrzewni drapieżcy",
        "Ranger",
        "Szósty zmysł",
        "Sztuka łucznicza",
        "Zasadzka",
      ],
    },
    Drzewoduch: {
      id: 8,
      startingEquipment: ["Broń naturalna (drzewcowa)"],
      cost: 180,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [3, 3, 0, 5, 5, 3, 3, 3, 8],
        Maksymalna: [3, 3, 0, 5, 5, 3, 3, 3, 8],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Leśny duch",
        "Łatwopalny",
        "Łuskowata skóra (4+)",
        "Oplątanie",
        "Wielkolud",
        "Zew dziczy",
      ],
    },
    "Wielki orzeł": {
      id: 9,
      startingEquipment: ["Broń naturalna (przebicie pancerza)"],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [2, 5, 0, 4, 4, 3, 4, 2, 8],
        Maksymalna: [2, 5, 0, 4, 4, 3, 4, 2, 8],
      },
      rules: ["Lot", "Potwór", "Wierzchowiec", "Zwierzę"],
    },
    Rydwan: {
      id: 10,
      startingEquipment: [],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        "Rumak Elfów": [9, 3, 0, 3, "-", "-", 4, 1, 5],
        "Rumak Elfów ": [9, 3, 0, 3, "-", "-", 4, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 12,
  name: "Leśni Elfowie z Athel Loren",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (2)", "Podatek", "Rozrzutność"],
  mercenaries: ["Minstrel", "Złodziej", "Zwiadowca"],
};
